import Button from "@mui/material/Button";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import Grid from "@mui/material/Grid";
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { convertFunctionNameToDescription } from "../../helpers/TestingHelper";
import { TestFunctionProps } from "../../helpers/TestingHelper";
import { useState, useEffect } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import Chip from '@mui/material/Chip';
import { navSliceActions } from "../../store/slices/NavSlice";
import { useStoreDispatch } from "../../store/Hooks";

interface TestProps {
    testFunction: any;
    individualFunction: TestFunctionProps;
}

const Test = (props: TestProps) => {
    const dispatch = useStoreDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [progress, setProgress] = useState<number>(0);
    const [testResult, setTestResult] = useState<boolean | null>(null);
    const [testFailReason, setTestFailReason] = useState<string | null>(null);

    const openDetails = () => {
        dispatch(
            navSliceActions.openModal({
                caresenseModalAlertType: "test_fail",
                caresenseModalAlertMessage: testFailReason,
                caresenseModalAlertEntityID: 0
            }),
        );
    }
    const description = convertFunctionNameToDescription(props.individualFunction.function_name);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);
    
    return (
        <Grid container spacing={0}>
            <Grid item xs={2}>
                <Button
                    onClick={async () => {
                        setIsLoading(true)
                        setTestResult(null)
                        const data = await props.testFunction().then((data: any) => {
                            setIsLoading(false)
                            setTestResult(true)
                        }).catch((err: Error) => {
                            console.log(typeof err)
                            console.log(err.message)
                            setIsLoading(false)
                            setTestResult(false)
                            setTestFailReason(err.message)
                        })

                    }}
                    style={{ marginTop: "15px" }}
                    variant="outlined"
                    color="success">
                    <PlayCircleFilledIcon />
                </Button>
            </Grid>
            <Grid item xs={3}>
                {isLoading && <LinearProgress style={{ marginTop: "30px", marginRight: "70px" }} variant="determinate" value={progress} />}
                {/* {testResult === true  && <Chip style={{marginTop:"15px", marginLeft:"-10px"}} color="success" label="TEST PASSED!" />} */}
                {testResult === true && <Chip style={{ marginTop: "15px", marginLeft: "-10px" }} color="success" label="TEST COMPLETED!" />}
                {testResult === false && <Chip
                    style={{ marginTop: "15px", marginLeft: "-10px", cursor:"pointer" }}
                    color="error"
                    label={<span style={{ textAlign: "center", padding: "10px" }}>
                        <div>TEST FAILED</div>
                        <div onClick={openDetails} style={{ textDecoration: "underline" }} >Details</div>
                    </span>
                    } />
                }
            </Grid>
            <Grid item xs={7}>
                <p>{description}</p>
            </Grid>
        </Grid>
    )
}



export default Test